export default __webpack_public_path__ + "static/media/socialScience-card-bg.40165dad.svg";